import { useTitle } from 'react-use';

import { Layout } from 'CorePackage/MainModule/components/Layout';

import { KnmList } from './KnmList';

export const KnmListPage = () => {
  useTitle('Список проверок');

  return (
    <Layout withFooter>
      <KnmList />
    </Layout>
  );
};
